// Email Inbox (sent-email history). Server: /api/auth/mails - ceo / cto / developer only;
// the server decides everything (filters, paging, who may see what), the client only shows it.
import config from "../../config.json";

const BASE = `${config.BASE_AUTH_API}mails`;

export class MailApiError extends Error {
  constructor(message, { status = 0, code = null } = {}) {
    super(message);
    this.name = "MailApiError";
    this.status = status;
    this.code = code;
  }
}

async function call(path, token, { method = "GET", signal, body } = {}) {
  let response;
  try {
    response = await fetch(`${BASE}${path}`, {
      method,
      headers: { Accept: "application/json", Authorization: `Bearer ${token}`, ...(body ? { "Content-Type": "application/json" } : {}) },
      ...(body ? { body: JSON.stringify(body) } : {}),
      signal,
    });
  } catch (error) {
    if (error?.name === "AbortError") throw error;
    throw new MailApiError("Network error", { code: "NETWORK" });
  }
  const data = await response.json().catch(() => ({}));
  if (!response.ok || data.success === false) {
    throw new MailApiError(data.message || "Request failed", { status: response.status, code: data.code || null });
  }
  return data;
}

// params: { page, limit, sort, order, q, status, type, source, storeId, application, from, to }
export const listMailsAPI = (token, params = {}, signal) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== "" && value !== null && value !== undefined) query.set(key, String(value));
  });
  return call(`?${query}`, token, { signal });
};

export const getMailFacetsAPI = (token, signal) => call("/facets", token, { signal });
export const getMailAPI = (token, id, signal) => call(`/${encodeURIComponent(id)}`, token, { signal });
// options.acknowledgeDuplicate: required by the server for an email whose outcome is unknown ("uncertain")
export const retryMailAPI = (token, id, options = {}) => call(`/${encodeURIComponent(id)}/retry`, token, { method: "POST", body: { acknowledgeDuplicate: options.acknowledgeDuplicate === true } });

// The file is fetched with the token and handed to the browser as a download; the URL is never shared.
export async function downloadMailAttachmentAPI(token, id, index, filename) {
  let response;
  try {
    response = await fetch(`${BASE}/${encodeURIComponent(id)}/attachments/${index}`, { headers: { Authorization: `Bearer ${token}` } });
  } catch (error) {
    throw new MailApiError("Network error", { code: "NETWORK" });
  }
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new MailApiError(data.message || "Download failed", { status: response.status, code: data.code || null });
  }
  const url = URL.createObjectURL(await response.blob());
  const link = document.createElement("a");
  link.href = url;
  link.download = filename || "attachment";
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
